import React, { useEffect, useMemo } from "react";

import _ from "lodash";
import cx from "classnames";
import styles from "./scenario.module.scss";
import Button from "src/components/button";
import { useDispatch } from "react-redux";
import { start } from "repl";
import { startSimulation } from "src/redux/actions/simulation/simulations";
import { useSelector } from "react-redux";
import { SimulationView } from "../simulation";
import { fetchScenario } from "src/redux/actions/simulation/scenarios";
import { useNavigate, useParams } from "react-router-dom";
import Thumbnail from "src/components/thumbnail";
import { OrganizationInfo, Persona } from "../simulation/about";
import { Media } from "src/types/media";

import DOMPurify from "dompurify";

const ScenarioPage = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id;

  const navigate = useNavigate();

  const { creating, loading, simulation, scenario } = useSelector(
    (state: any) => {
      const scenarioState = _.get(state, `scenarios.scenario.${id}`);
      const creating = _.get(scenarioState, "simulation.creating");
      const simulation = _.get(scenarioState, "simulation.item");
      const loading = _.get(scenarioState, "loading", false);
      return {
        creating,
        loading,
        simulation,
        scenario: scenarioState?.item,
      };
    },
    _.isEqual,
  );

  const handleStartSimulation = () => {
    console.log("Starting simulation...");
    if (id) {
      dispatch(startSimulation({ scenario: id }));
    }
  };

  const getScenarioTitle = () => {
    const callType = _.get(scenario, "callSettings.callType", "Discovery");
    const companyName = _.get(scenario, "company.name", "");
    const prospectDesignation = _.get(scenario, "prospect.designation", "");
    return `${callType} Call - ${companyName} - ${prospectDesignation}`;
  };

  const name = useMemo(
    () => _.get(scenario, "name"),
    [scenario],
  )

  const description = useMemo(
    () => _.get(scenario, "description"),
    [scenario],
  );

  const banner = useMemo(() => {
    const image = _.get(scenario, "banner");
    if (image) {
      return {
        id: image,
        key: image,
        type: "image",
      } as Media;
    }

    return null;
  }, [scenario]);

  useEffect(() => {
    // Fetch scenario details
    dispatch(fetchScenario(id as string));
  }, []);

  if (simulation) {
    return <SimulationView simulation={simulation} />;
  }

  if (loading) {
    return <PlaceholderScenarioPage />;
  }

  return (
    <section className={styles.container}>
      <div className={styles.left}>
        <div
          className={styles.backArrow}
          onClick={() => navigate("/coaching/explore")}
        >
          <i className={cx(styles.icon, "paperflite-left-arrow")} />
          <span>explore</span>
        </div>

        <div className={styles.details}>
          <header className={styles.heading}>{_.get(scenario, "name")}</header>
          <div className={styles.thumbnailWrapper}>
            <Thumbnail
              className={styles.thumbnail}
              media={banner}
              defaultImage="/images/coaching/default_course.jpg"
            />

            <Button
              className={styles.joinCall}
              icon="fa fa-phone"
              text={creating ? "Starting..." : "Start Call"}
              disabled={creating}
              variant="gradient"
              onClick={handleStartSimulation}
            />
          </div>

          <div className={styles.actions}>
            <div className={styles.item}>
              <i className="paperflite-clock" />
              <span>{_.get(scenario, "callSettings.duration")} minutes</span>
            </div>
            <div className={styles.border} />
            <div className={styles.item}>
              <i className="paperflite-calendar" />
              <span>{_.get(scenario, "callSettings.callType")}</span>
            </div>
            <div className={styles.border} />
            <div className={styles.item}>
              <i className="paperflite-rocket" />
              <span>Complex</span>
            </div>
          </div>
        </div>

        <div className={styles.description}>
          <header className={styles.heading}>Description</header>
          <div
            className={styles.summary}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
          />
        </div>
      </div>
      <div className={styles.right}>
        <span className={styles.verticalLine} />

        <OrganizationInfo company={_.get(scenario, "company")} />

        <Persona prospect={_.get(scenario, "prospect")} />
      </div>
    </section>
  );
};

const PlaceholderScenarioPage = () => {
  return (
    <section className={cx(styles.container, styles.placeholder)}>
      <div className={styles.left}>
        <div className={styles.details}>
          <div className={styles.thumbnailWrapper}>
            <div className={cx(styles.thumbnail, styles.block)}></div>
          </div>

          <div className={styles.actions}>
            <div className={cx(styles.item, styles.block)}></div>
            <div className={styles.border} />
            <div className={cx(styles.item, styles.block)}></div>
            <div className={styles.border} />
            <div className={cx(styles.item, styles.block)}></div>
          </div>
        </div>

        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />
      </div>
      <div className={cx(styles.right)}>
        <span className={styles.verticalLine} />
        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />
        <div className={cx(styles.description, styles.block)} />

      </div>
    </section>
  );
};

export default ScenarioPage;
